import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory, withRouter } from 'react-router';
import ShowEvents from '../components/events/ShowEvents';
import { clearAuthErrors, fetchEvents, clearEventsErrors } from '../actions';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import Pagination from '../components/home/Pagination';
import TextField from 'material-ui/TextField';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  events: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
};

class EventsPage extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    // TODO: fix authentication - gabo
    if (!this.props.isAuthenticated) {
      this.props.dispatch(clearAuthErrors());
      browserHistory.goBack();
    }
    this.props.dispatch(clearEventsErrors());
    const query = this.props.query;
    // const selectLimit = { tenant: query.tenant, limit: 1000 };
    const router = this.props.router;
    if (this.props.events.search && this.props.events.search.length > 0) {
      query.search = this.props.events.search;
    }
    if (!query.page) {
      query.page = 1;
      router.push({ pathname: '/events', query });
    } else {
      // this.props.dispatch(fetchOptions(selectLimit));
      // this.props.dispatch(fetchOptionGroups(selectLimit));
      // this.props.dispatch(fetchCategories(selectLimit));
      this.props.dispatch(fetchEvents(query));
    }
  }
  handleSearchChange(e) {
    const events = this.props.events;
    const query = this.props.query;
    const router = this.props.router;
    const nextEventInput = e.target.value;
    const nextEvent = (nextEventInput !== '') ? nextEventInput : '';
    events.search = nextEvent;
    this.setState({
      events,
    });
    if (nextEvent.length > 0) {
      query.search = nextEvent;
    } else {
      delete query.search;
    }
    query.page = 1;
    router.push({ pathname: '/events', query });
    this.props.dispatch(fetchEvents(query));
  }
  navigation(route) {
    this.props.dispatch(fetchEvents(route));
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '1%',
      },
    };
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="events component" style={authPage}>
        <span style={{ display: 'none', fontFamily: 'Marydale' }}>.</span>
        <h2>Events</h2>
        <div className="content">
          <div className="action-buttons top">
            <TextField
              floatingLabelText="Search by Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              inputStyle={styles.inputStyle}
              value={this.props.events.search}
              onChange={this.handleSearchChange}
            />
            <Pagination
              paginationInfo={this.props.events.meta}
              pageCall={route => this.navigation(route)}
            />
          </div>
          <hr />
          <ShowEvents
            events={this.props.events.results}
          />
        </div>
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.events.meta}
            pageCall={route => this.navigation(route)}
          />
        </div>
      </div>
    );
  }
}

EventsPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EventsPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    events: state.events,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(EventsPage));



// WEBPACK FOOTER //
// ./src/containers/EventsPage.js